var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 23 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.188 15.926V8.97c0-4.802-3.554-8.694-7.938-8.694S3.313 4.168 3.313 8.97v6.956L.138 22.882H7.36c.368 1.984 1.969 3.478 3.889 3.478s3.521-1.494 3.889-3.478h7.224zm-7.938 8.695c-1.035 0-1.907-.728-2.235-1.739h4.471c-.329 1.011-1.2 1.739-2.236 1.739m-8.731-3.478L4.9 15.926V8.97c0-3.84 2.843-6.955 6.35-6.955S17.6 5.129 17.6 8.97v6.956l2.381 5.217z"
  })));
};
export default SvgBell;